<div *ngIf="isLoading">Loading Gender List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="gender" [(ngModel)]="model.gender" [required]="required">
  <option *ngFor="let singleGender of genders" [ngValue]="singleGender">{{ singleGender.name }}</option>
</select>
